import { render, staticRenderFns } from "./EmployeeGeneralDetailForm.vue?vue&type=template&id=cc2c918a&scoped=true&"
import script from "./EmployeeGeneralDetailForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeGeneralDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2c918a",
  null
  
)

export default component.exports